import { Box, Divider, IconButton, styled, Typography } from '@mui/material';
import { IconCall, IconCross, IconInbox } from 'assets/img';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { UserAvatar } from 'redesign';
import { SignDocumentHeaderProps } from './sign-document-dialog-header.types';

export const SignDocumentDialogHeader = ({
  onClose,
  firstName,
  lastName,
  infix,
  phoneNumber,
  email,
}: SignDocumentHeaderProps) => {
  return (
    <>
      <Box>
        <HeaderWrapper>
          <FlexRowBoxCenter onClick={() => {}} role="fw-profile">
            <ImageWrap>
              <UserAvatar firstName={firstName} lastName={lastName} width={14} height={14} />
            </ImageWrap>

            <Typography variant="h3" fontWeight={500} noWrap>
              {getFullNameWithInfix({ firstName, infix, lastName })}
            </Typography>
          </FlexRowBoxCenter>

          <InfoWrap>
            <Box display="flex" flexDirection="row">
              <StyledIcon width={24} height={24} as={IconCall} />
              <CredentialText paddingRight={5} noWrap>
                {phoneNumber}
              </CredentialText>
            </Box>
            <Box display="flex" flexDirection="row">
              <StyledIcon width={24} height={24} as={IconInbox} />
              <CredentialText noWrap>{email}</CredentialText>
            </Box>
            <Box display="flex" flexDirection="row">
              <IconButton onClick={onClose}>
                <IconCross width={24} height={24} />
              </IconButton>
            </Box>
          </InfoWrap>
        </HeaderWrapper>
        <Divider />
      </Box>
    </>
  );
};

const ImageWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(2),
}));

const FlexRowBoxCenter = styled(Box)(() => ({
  alignItems: 'center',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'flex',
  flexDirection: 'row',
}));

const HeaderWrapper = styled(FlexRowBoxCenter)(({ theme }) => ({
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(3),
  cursor: 'pointer',
  overflow: 'hidden',
}));

const CredentialText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  marginLeft: theme.spacing(1),
  opacity: '0.6',
}));

const InfoWrap = styled(FlexRowBoxCenter)(() => ({
  marginLeft: 'auto',
  cursor: 'default',
}));

const StyledIcon = styled('svg')(() => ({
  '& path': {
    stroke: 'rgba(0, 0, 0, 0.4)',
  },
}));
